var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SendHistory", { attrs: { histories: _vm.histories } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }